// extracted by mini-css-extract-plugin
export var project = "Project-module--project--2WM5G";
export var project__icon = "Project-module--project__icon--QOe75";
export var project__categories = "Project-module--project__categories--3y3T0";
export var project__name = "Project-module--project__name--1ToAj";
export var project__category = "Project-module--project__category--SCXxq";